module.exports = __webpack_public_path__ + "img/qBTC.f8d31578.svg";